export default "__VITE_ASSET__bMbLbZsO__"